import axios from 'axios'
import { API_STRUCTURE, API_OCR } from '../../config/config.json'
import { decryptStorage } from 'utils/utils';
import { structureServiceId } from 'config/constants';
export async function radicationText(data) {
  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };
  return await axios.post(`${API_STRUCTURE}/radication-text`, data, { headers }).then(res => {
    return { text: res.data.data, status: 'success' }
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function getTermsAndConditions(data) {
  let headers;
  const token = decryptStorage(localStorage.getItem("token"));
  const tokenRevocationGSE = decryptStorage(localStorage.getItem("tokenRevocationGSE"));
  if (token) headers = { Authorization: `Bearer ${token}` };
  if (tokenRevocationGSE) headers = { Authorization: `Bearer ${tokenRevocationGSE}` };
  return await axios.post(`${API_STRUCTURE}/terms-and-conditions`, { ...data, "structureServiceId": structureServiceId }, { headers }).then(res => {
    return { data: res.data.data, status: 'success' }
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function getDataTreatment(data) {
  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };
  return await axios.post(`${API_STRUCTURE}/data-treatment`, { ...data, "structureServiceId": structureServiceId }, { headers }).then(res => {
    return { data: res.data.data, status: 'success' }
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function structureForm(data) {
  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };
  return await axios.post(`${API_STRUCTURE}/structure-form`, data, { headers })
    .then(res => {
      return { data: res.data.data.structureForm, status: 'success', ocrFlags: res.data.data.ocrFlags }
    }).catch(err => {
      console.log("Error obteniendo estructura.")
      // return { data: { message: err.message }, status: 'error' }
    })
}

export async function countries() {
  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };
  return await axios.get(`${API_STRUCTURE}/countries`, { headers }).then(res => {
    return { data: res.data.data, status: 'success' }
  }).catch(err => {
    console.log("Error obteniendo paises.")
    //return { data: { message: err.message }, status: 'error' }
  })
}

export async function states(data) {
  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };
  return await axios.post(`${API_STRUCTURE}/states`, data, { headers }).then(res => {
    return { data: res.data.data, typeName: data.typeName, status: 'success' }
  }).catch(err => {
    console.log("Error obteniendo estados.")
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function towns(data) {
  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };
  return await axios.post(`${API_STRUCTURE}/towns`, data, { headers }).then(res => {
    if (res.status == '222') throw ({ message: 'Error inesperado' });
    return { data: res.data.data, typeName: data.typeName, status: 'success' }
  }).catch(err => {
    console.log("Error obteniendo ciudades.")
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function typesIdentification() {
  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };
  return await axios.get(`${API_STRUCTURE}/identification-type`, { headers }).then(res => {
    return { data: res.data.data.identificationType, status: 'success' }
  }).catch(err => {
    console.log("Error obteniendo tipos de identificacion.")
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function certificateUses() {
  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };
  return await axios.get(`${API_STRUCTURE}/use-certificate`, { headers }).then(res => {
    return { data: res.data.data.useCertificate, status: 'success' }
  }).catch(err => {
    console.log("Error obteniendo tipos de uso.")
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function consultParametrizableDataQueryFiles(data) {
  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };
  return await axios.post(`${API_STRUCTURE}/consult-query-info-files`, data, { headers }).then(res => {
    return { data: res.data.data, status: 'success' }
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}


export async function saveFilesApi(dataSend) {

  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'post',
    url: `${API_OCR}/RegisterRequest`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    data: JSON.stringify(dataSend)
  };
  return await axios.request(config)
    .then(response => {
      return { data: response.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}

export async function getDocumentDataApi(data) {
  let token = decryptStorage(localStorage.getItem("token"))
  let config = {
    method: 'get',
    url: `${API_OCR}/getDocumentData`,
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json',
      "externalRequestId": data.crId
    }
  };
  return await axios.request(config)
    .then(response => {
      return { data: response.data.data, status: 'success' }
    }).catch(error => {
      return { data: { message: error.message }, status: 'error' }
    });
}